import {getUrlParameter} from "./urlHelpers";

export function initNeedHelpButton() {
    $(".btn-need-help").click(function (e) {
        e.preventDefault();

        if (typeof window.smartsupp !== "function") {
            return;
        }

        const placeNumber = $(this).data("place-number");
        const placeName = $(this).data("place-name");
        //objednávkový formulář může být i bez konkrétního objektu
        const message = placeName
            ? "Dobrý den, mám dotaz k objektu " + placeNumber + " – " + placeName + "."
            : "Dobrý den, mám dotaz k objednávce pobytu.";

        window.smartsupp("chat:message", message);
        window.smartsupp("chat:open");
    });
}

export function initNeedHelpWhatsappButton() {
    $(".btn-need-help-whatsapp").click(function (e) {
        e.preventDefault();

        const phone = $(this).data("phone");
        const lines = ["Dobrý den, prosím o radu k objednávce pobytu."];

        //objekt je buď pevně daný, nebo ho uživatel vyplnil ve formuláři
        const placeNumber = $(this).data("place-number") || $("#reservation_placeNumber").val();
        const placeName = $(this).data("place-name") || $("#reservation_placeName").val();
        const place = [placeNumber, placeName].filter(Boolean).join(" – ");
        if (place) {
            lines.push("Objekt: " + place);
        }

        const apartment = $(this).data("apartment") || getUrlParameter("apartment");
        if (apartment) {
            lines.push("Varianta: " + apartment);
        }

        const dateRange = $(this).data("date-range") || $("#reservation_dateString").val();
        if (dateRange) {
            lines.push("Termín: " + dateRange);
        }

        //nové okno, ať uživatel nepřijde o vyplněný formulář
        window.open("https://wa.me/" + phone + "?text=" + encodeURIComponent(lines.join("\n")), "_blank");
    });
}
